const APP_TOKEN_NAME = 'token'
const ITEM_PER_PAGE = 10
const SEND_TYPE_PUSH = 1
const SEND_TYPE_MAIL = 2
const SEND_TYPE_BOTH = 3
const SCHEDULE_CANCEL_DATE = 1
const SCHEDULE_CANCEL_DAY = 2
const SCHEDULE_CANCEL_PERIOD = 3
const SCHEDULE_BOOKING = 4
const ROUTE_PICKUP = 1
const ROUTE_DROP = 2
const ROUTE_BOTH = 3
const STUDENT_STATUS_CANCEL = 0
const STUDENT_NOT_CHECKED_IN = 1
const STUDENT_CHECKED_IN = 2
const STUDENT_CHECKED_OUT = 3
const DAY_OFF_TYPE_DATE = 1
const DAY_OFF_TYPE_DAY = 2
const DAY_OFF_TYPE_PERIOD = 3
const DEFAULT_LANG = 'ja'
const NOTIFICATION_TEMPLATE_REASON_STRING = 1
const NOTIFICATION_TEMPLATE_REASON_DATE = 2
const NOTIFICATION_TEMPLATE_REASON_TEXT_BOX = 3
const ATTACHMENT_TYPE_SUB_DRIVER = 1
const ATTACHMENT_TYPE_PARENT = 2
const ATTACHMENT_TYPE_PICKUP_ROUTE = 3
const ATTACHMENT_TYPE_DROP_ROUTE = 4
const GENDER_FEMALE = 0
const GENDER_MALE = 1
const GENERATE_TIME_PICKUP = '5:00'
const GENERATE_TIME_DROP = '11:30'
const GENERATE_DEADLINE_TIME_DROP = '13:00'
const USER_TYPE_SUB_DRIVER = 1
const USER_TYPE_PARENT = 2
const USER_NOTIFICATION_TYPE_PARENT = 'parent'
const USER_NOTIFICATION_TYPE_PARENT_UPDATE = 'parent-update'
const USER_NOTIFICATION_TYPE_BUS = 'bus'
const USER_NOTIFICATION_TYPE_CANCEL = 'cancel'
const USER_NOTIFICATION_TYPE_AUTHORIZED_PERSON = 'authorized-person'
const USER_NOTIFICATION_TYPE_PARENT_APPROVE='parent-approve'
const USER_NOTIFICATION_TYPE_STUDENT_NEW = "student-new"
const USER_NOTIFICATION_TYPE_REJECT_PARENT ="reject_parent"
const USER_NOTIFICATION_TYPE_APPROVE_PARENT="approve_parent"
const FLAG_NO = 0
const FLAG_YES = 1
const FOLLOWDAY = 1
const FOLLOWRANGERDAY = 0

const WORKING_DAY_LIST = {
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday'
}

const DAY_LIST = {
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
}

const DAY_LIST_FULL = {
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
  7: 'sunday'
}

const MONTH_LIST = {
  1: 'jan',
  2: 'feb',
  3: 'mar',
  4: 'apr',
  5: 'may',
  6: 'jun',
  7: 'jul',
  8: 'aug',
  9: 'sep',
  10: 'oct',
  11: 'nov',
  12: 'dec'
}

const SEND_NOTIFICATION_ONLY_PUSH = 1
const SEND_NOTIFICATION_ONLY_EMAIL = 2
const SEND_NOTIFICATION_BOTH = 3
const CANNOT_SEND = -1
const NOT_YET_SEND = 0
const NEED_SEND = 1
const SENT = 2
const ACTIVE = 1
const NOT_ACTIVE = 0
const AUTHORIZED_PERSON_TYPE_DATE = 1
const AUTHORIZED_PERSON_TYPE_RANGE = 2

export {
  NOT_ACTIVE,
  ACTIVE,
  FOLLOWDAY,
  CANNOT_SEND,
  NOT_YET_SEND,
  NEED_SEND,
  SENT,
  FOLLOWRANGERDAY,
  APP_TOKEN_NAME,
  ITEM_PER_PAGE,
  SEND_TYPE_PUSH,
  SEND_TYPE_MAIL,
  SEND_TYPE_BOTH,
  SCHEDULE_CANCEL_DATE,
  SCHEDULE_CANCEL_DAY,
  SCHEDULE_CANCEL_PERIOD,
  SCHEDULE_BOOKING,
  ROUTE_PICKUP,
  ROUTE_DROP,
  ROUTE_BOTH,
  DAY_LIST,
  STUDENT_STATUS_CANCEL,
  STUDENT_NOT_CHECKED_IN,
  STUDENT_CHECKED_IN,
  STUDENT_CHECKED_OUT,
  DAY_OFF_TYPE_DATE,
  DAY_OFF_TYPE_DAY,
  DAY_OFF_TYPE_PERIOD,
  DAY_LIST_FULL,
  MONTH_LIST,
  DEFAULT_LANG,
  NOTIFICATION_TEMPLATE_REASON_STRING,
  NOTIFICATION_TEMPLATE_REASON_DATE,
  NOTIFICATION_TEMPLATE_REASON_TEXT_BOX,
  ATTACHMENT_TYPE_PARENT,
  ATTACHMENT_TYPE_SUB_DRIVER,
  ATTACHMENT_TYPE_PICKUP_ROUTE,
  ATTACHMENT_TYPE_DROP_ROUTE,
  GENDER_FEMALE,
  GENDER_MALE,
  GENERATE_TIME_PICKUP,
  GENERATE_TIME_DROP,
  USER_TYPE_SUB_DRIVER,
  USER_TYPE_PARENT,
  USER_NOTIFICATION_TYPE_PARENT,
  USER_NOTIFICATION_TYPE_PARENT_UPDATE,
  USER_NOTIFICATION_TYPE_BUS,
  USER_NOTIFICATION_TYPE_CANCEL,
  SEND_NOTIFICATION_ONLY_PUSH,
  SEND_NOTIFICATION_ONLY_EMAIL,
  SEND_NOTIFICATION_BOTH,
  GENERATE_DEADLINE_TIME_DROP,
  FLAG_NO,
  FLAG_YES,
  WORKING_DAY_LIST,
  USER_NOTIFICATION_TYPE_AUTHORIZED_PERSON,
  AUTHORIZED_PERSON_TYPE_DATE,
  AUTHORIZED_PERSON_TYPE_RANGE,
  USER_NOTIFICATION_TYPE_PARENT_APPROVE,
  USER_NOTIFICATION_TYPE_APPROVE_PARENT,
  USER_NOTIFICATION_TYPE_REJECT_PARENT,
  USER_NOTIFICATION_TYPE_STUDENT_NEW
}
